import { render, staticRenderFns } from "./BildungsMaterialList.vue?vue&type=template&id=0cc9b0e0&scoped=true&"
import script from "./BildungsMaterialList.vue?vue&type=script&lang=js&"
export * from "./BildungsMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./BildungsMaterialList.vue?vue&type=style&index=0&id=0cc9b0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9b0e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VChip,VCol,VRow,VSelect})
